import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useFeatureFlagStore } from '~/zustand/featureFlag/useFeatureFlagStore';
import { useEnsureProfile } from './useEnsureProfile';

export default function useRefreshFeatureFlags() {
  const [hasRefreshed, setHasRefreshed] = useState(false);
  const location = useLocation();
  const profile = useEnsureProfile();

  const refreshAllFlags = useFeatureFlagStore(state => state.refreshAllFlags);

  useEffect(() => {
    const shouldRefresh = location.pathname === '/' || location.pathname === '/real-photos';
    if (shouldRefresh && !hasRefreshed && profile.veiling_claim_type_email) {
      refreshAllFlags(profile.veiling_claim_type_email);
      setHasRefreshed(true);
    }
  }, [location, refreshAllFlags, hasRefreshed, profile.veiling_claim_type_email]);
}
